function popupHandler(e) {
  e.preventDefault();
  //[data-popuptrigger]
  const popupSelector = e.currentTarget.dataset.popuptrigger;
  const popupEl = document.querySelector(popupSelector);

  showOverlay();
  popupEl.classList.add('active');
}

function anyInClosePopupOverlay(e) {
  hideOverlay();
  e.target.closest('.popup').classList.remove('active');
}

function anyOutClosePopupOverlay(e) {
  hideOverlay();
  document.querySelector('.popup.active').classList.remove('active');
}

function closePopupHandler(e) {
  hideOverlay();
  e.target.closest('.popup').classList.remove('active');
}

function showOverlay() {
  popupDoFreeze();
  document.querySelector('.overlay').classList.add('active');
}

function hideOverlay() {
  popupUnFreeze();
  document.querySelector('.overlay').classList.remove('active');
}

function startPopups() {
  document.querySelectorAll('[data-popuptrigger]').forEach((element) => {
    element.addEventListener('click', popupHandler);
  });

  document.querySelectorAll('.popup__close').forEach((element) => {
    element.addEventListener('click', closePopupHandler);
  });

  document
    .querySelector('.overlay')
    .addEventListener('click', anyOutClosePopupOverlay);
}

function popupDoFreeze() {
  const html = document.querySelector('html');

  if (html.classList.contains('freeze')) {
    html.classList.remove('freeze');
    // html.style.setProperty('--scrollbar-width', '');
  } else {
    html.classList.add('freeze');
    html.style.setProperty(
      '--scrollbar-width',
      `${popupGetScrollbarWidth()}px`
    );
  }
}

function popupUnFreeze() {
  const html = document.querySelector('html');
  html.classList.remove('freeze');
  // html.style.setProperty('--scrollbar-width', '');
}

function popupGetScrollbarWidth() {
  const scrollDiv = document.createElement('div');
  scrollDiv.style.cssText =
    'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
  document.body.appendChild(scrollDiv);
  const scrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollBarWidth;
}

if (document.querySelector('.popup')) {
  startPopups();
}
